export default {
    p: {
        urc: {
            title: 'Registration Channels',
            msg: {
                loadFailed: 'Failed to load registration channels',
            },
            columns: {
                name: 'Channel Name',
                code: 'Channel Code',
                userCount: 'Registered Users',
                createdAt: 'Created At',
            },
        },
    },
};
